import { render, staticRenderFns } from "./b2b_doc_update.vue?vue&type=template&id=771ff17f"
import script from "./b2b_doc_update.vue?vue&type=script&lang=js"
export * from "./b2b_doc_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports